module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": _vm.name,
      "height": "auto"
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.header))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('description')
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.description),
      expression: "unit.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "type": "text",
      "id": "description",
      "name": "description"
    },
    domProps: {
      "value": (_vm.unit.description)
    },
    on: {
      "keyup": function($event) {
        return _vm.productLiveSearch(_vm.unit.description)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-height": "250px"
    },
    attrs: {
      "id": "productCustomLiveSearch"
    }
  }, [_vm._l((_vm.productrows), function(product, pIdx) {
    return [_c('div', {
      key: pIdx,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.productSelected(product)
        }
      }
    }, [_vm._v(_vm._s(product))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.level === 2),
      expression: "level === 2"
    }],
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "includeInTransferOrder"
    }
  }, [_vm._v("Incl. w/ Transfer Order")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.includeInTransferOrder),
      expression: "unit.includeInTransferOrder",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "includeInTransferOrder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.unit, "includeInTransferOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('quantity')
  }, [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.quantity),
      expression: "unit.quantity",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:0|min_value:1'),
      expression: "'required|decimal:0|min_value:1'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "autocomplete": "off",
      "id": "quantity",
      "name": "quantity",
      "min": "1"
    },
    domProps: {
      "value": (_vm.unit.quantity)
    },
    on: {
      "blur": [function($event) {
        return _vm.getLotNumbers(_vm.unit.internalId, _vm.unit.quantity);
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "quantity", _vm._n($event.target.value))
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.level === 2),
      expression: "level === 2"
    }],
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('lot')
  }, [_c('label', {
    attrs: {
      "for": "lot"
    }
  }, [_vm._v("Lot # "), _c('small', [_vm._v(_vm._s(this.unit.lot ? this.unit.lot + " " + this.unit.available : ""))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.lot),
      expression: "unit.lot"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "lot",
      "name": "lot",
      "disabled": _vm.fullLotList.length == 0
    },
    domProps: {
      "value": (_vm.unit.lot)
    },
    on: {
      "keyup": function($event) {
        return _vm.lotLiveSearch(_vm.unit.lot)
      },
      "click": function($event) {
        return _vm.showLots()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "lot", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.fullLotList.length > 0) ? _c('div', {
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-height": "250px"
    },
    attrs: {
      "id": "lotCustomLiveSearch"
    }
  }, [_vm._l((_vm.lotRows), function(lot, lIdx) {
    return [_c('div', {
      key: lIdx,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.lotSelected(lot)
        }
      }
    }, [_vm._v(_vm._s(lot.name + ' (' + lot.available + ')'))])]
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('v-error', {
    attrs: {
      "err": _vm.errors,
      "id": "description"
    }
  }), _vm._v(" "), _c('v-error', {
    attrs: {
      "err": _vm.errors,
      "id": "quantity"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('length')
  }, [_c('label', {
    attrs: {
      "for": "length"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.length),
      expression: "unit.length",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0.001|max_value:1000'),
      expression: "'required|min_value:0.001|max_value:1000'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "length",
      "name": "length",
      "min": "0.001",
      "max": "1000"
    },
    domProps: {
      "value": (_vm.unit.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "length", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('width')
  }, [_c('label', {
    attrs: {
      "for": "width"
    }
  }, [_vm._v("Width")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.width),
      expression: "unit.width",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0.001|max_value:1000'),
      expression: "'required|min_value:0.001|max_value:1000'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "width",
      "name": "width",
      "min": "0.001",
      "max": "1000"
    },
    domProps: {
      "value": (_vm.unit.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "width", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('height')
  }, [_c('label', {
    attrs: {
      "for": "height"
    }
  }, [_vm._v("Height")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.height),
      expression: "unit.height",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0.001|max_value:1000'),
      expression: "'required|min_value:0.001|max_value:1000'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "height",
      "name": "height",
      "min": "0.001",
      "max": "1000"
    },
    domProps: {
      "value": (_vm.unit.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "height", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('dimensionunit')
  }, [_c('label', {
    attrs: {
      "for": "dimensionunit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.dimensionunit),
      expression: "unit.dimensionunit",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dimensionunit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.unit, "dimensionunit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Inches")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Feet")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Centimeters")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Meters")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('v-error', {
    attrs: {
      "err": _vm.errors,
      "id": "length"
    }
  }), _vm._v(" "), _c('v-error', {
    attrs: {
      "err": _vm.errors,
      "id": "width"
    }
  }), _vm._v(" "), _c('v-error', {
    attrs: {
      "err": _vm.errors,
      "id": "height"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('weight')
  }, [_c('label', {
    attrs: {
      "for": "weight"
    }
  }, [_vm._v("Weight")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.weight),
      expression: "unit.weight",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0.001|max_value:10000'),
      expression: "'required|min_value:0.001|max_value:10000'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "weight",
      "name": "weight",
      "min": "0.001",
      "max": "10000"
    },
    domProps: {
      "value": (_vm.unit.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "weight", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon su-group-addon"
  }, [_vm._v("per unit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.error('weight')
  }, [_c('label', {
    attrs: {
      "for": "weightunit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.unit.weightunit),
      expression: "unit.weightunit",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "weightunit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.unit, "weightunit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Lb")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Kg")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('v-error', {
    attrs: {
      "err": _vm.errors,
      "id": "weight"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-actions float-right",
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Done")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-741fd030"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shippinglvls/ShippingLvlModal.vue
// module id = 738
// module chunks = 0